









import Vue from 'vue'
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
export default Vue.extend({
    components: {
        Breadcrumbs
    }
})
